// extracted by mini-css-extract-plugin
module.exports = {"landingSection":"LandingSection_landingSection__2NKX8","landingSectionFixedBG":"LandingSection_landingSectionFixedBG__1uvqg"};